module.exports = __webpack_public_path__ + "static/media/gusonpeatmoss.0302af27.jpg";